import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { NbRangepickerComponent } from '@nebular/theme/components/datepicker/datepicker.component';
import * as moment from 'moment';
import { DaterangepickerComponent } from 'ngx-daterangepicker-material';
import { Filter } from '../../../../shared/constants/Filters';
import { DashboardFilter } from '../../../../shared/models/company/dashboardFilter';
import { DashboardComunicationService } from '../../../dashboard/dashboard/dashboard-comunication.service';
import { BrandSelectionDropdownComponent } from '../../dropdown/brand-selection-dropdown/brand-selection-dropdown.component';
import { ChannelSelectionDropdownComponent } from '../../dropdown/channel-selection-dropdown/channel-selection-dropdown.component';
import { CompanySelectionDropdownComponent } from '../../dropdown/company-selection-dropdown/company-selection-dropdown.component';
import { TypeSelectionDropdownComponent } from '../../dropdown/type-selection-dropdown/type-selection-dropdown.component';

// TODO All filters use the LeadFiltersComponent.

@Component({
  selector: 'ngx-new-dashboard-filter',
  templateUrl: './new-dashboard-filter.component.html',
  styles: [`
  @media only screen and (max-width: 991px) {
    :host ::ng-deep ngx-daterangepicker-material {
      right: 50vw;
    }
  }

  @media only screen and (max-width: 480px) {
    :host ::ng-deep ngx-daterangepicker-material {
      right: 75vw;
    }
  }

  :host ::ng-deep ngx-daterangepicker-material {
    position: absolute;
  }

  :host ::ng-deep .calendar.right {
    display: none !important;
  }
`]
})
export class NewDashboardFilterComponent implements AfterViewInit {

  filter: DashboardFilter = new DashboardFilter();

  @ViewChild(NbRangepickerComponent, { static: false }) closeDateEl: NbRangepickerComponent<Date>;

  @ViewChild(NbRangepickerComponent, { static: false }) createDatePicker: NbRangepickerComponent<Date>;

  @ViewChild(NbRangepickerComponent, { static: false }) updatedDatePicker: NbRangepickerComponent<Date>;

  @ViewChild(NbRangepickerComponent, { static: false }) archivedDateEl: NbRangepickerComponent<Date>;
  @ViewChild(CompanySelectionDropdownComponent, { static: false })
  companiesSelectionComponent: CompanySelectionDropdownComponent;
  @ViewChild(ChannelSelectionDropdownComponent, { static: false })
  channelSelectionComponent: ChannelSelectionDropdownComponent;
  @ViewChild(BrandSelectionDropdownComponent, { static: false })
  brandSelectionComponent: BrandSelectionDropdownComponent;
  @ViewChild(TypeSelectionDropdownComponent, { static: false })
  typesSelectionComponent: TypeSelectionDropdownComponent;

  picker: DaterangepickerComponent;
  today = moment();
  sending: boolean;
  isPageLoaded: any;
  closeDateRange: { start: Date; end: Date; };
  archivedDateRange: { start: Date; end: Date; };
  archivedNotContacted: boolean;
  archivedNotInterested: boolean;
  archivedOther: boolean;
  filterClosed: boolean;
  filterArchived: boolean;
  rangeVisit: { start: Date; end: Date };
  rangeReminder: { start: Date; end: Date };
  filterOnTrackCold: boolean;
  filterOnTrackWarm: boolean;
  filterOnTrackHot: boolean;
  filterNewLead: boolean;
  rangeCreate: { start: Date; end: Date };
  rangeUpdate: { start: Date; end: Date };
  rangeUpdatedSelected: string;
  filterDateUpdate: string;

  typeReminder: string;
  rangeSelected: string;
  dateModel: string;
  filterDate: string;

  filterContacteds = false;
  filterNotContacteds = false;
  filterOnCall = false;
  filterOnPrequalification = false;
  filterReminders = false;
  filterVisits = false;
  filterTransfereds = false;
  dateUpdateModel: string;
  onTrackModal: string;

  channelSelected: any;
  brandsSelected: any;
  typesSelected: any;
  companySelected: any;
  status: string;

  constructor(private readonly dashboardComuService: DashboardComunicationService) {
    this.sending = false;
    this.closeDateRange = { start: null, end: null };
    this.rangeVisit = { start: null, end: null };
    this.rangeReminder = { start: null, end: null };
    this.rangeCreate = { start: null, end: null };
    this.rangeUpdate = { start: null, end: null };
    this.archivedDateRange = { start: null, end: null };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isPageLoaded = true;
      this.generateFilterFromLocalStorage();
      this.applyFilter();
    });
  }

  applyFilter(): void {
    this.sending = true;

    this.filter.companies = this.companiesSelectionComponent.selectedItems.map(company => company.id);
    // this.filter.channels = this.channelSelectionComponent.selectedItems.map(channel => channel.id);
    // this.filter.leadTypes = this.typesSelectionComponent.selectedItems.map(type => type.id);
    // this.filter.brands = this.brandSelectionComponent.selectedItems.map(brand => brand.id);

    // this.filter.filterClosed = this.filterClosed;
    this.visitDateRangeForFilter();
    this.reminderDateRangeForFilter();
    this.closedDateRangeForFilter();

    this.createDateRangeForFilter();
    this.createDateUpdateRangeForFilter();

    this.archivedDateRangeForFilter();
    if (this.filterArchived) {
      this.filter.archivedOption = [];
      if (this.archivedNotContacted) {
        this.filter.archivedOption.push('not_contacted');
      }
      if (this.archivedNotInterested) {
        this.filter.archivedOption.push('not_interested');
      }
      if (this.archivedOther) {
        this.filter.archivedOption.push('other');
      }
    } else {
      this.filter.archivedComment = '';
    }

    const filterForView = {
      brands: this.brandSelectionComponent.selectedItems,
      channels: this.channelSelectionComponent.selectedItems,
      filterDate: this.dateModel,
      leadTypes: this.typesSelectionComponent.selectedItems,
      filterDateUpdate: this.dateUpdateModel,
      rangeSelected: this.rangeSelected,
      rangeReminder: this.rangeReminder,
      rangeVisit: this.rangeVisit,
      onCall: this.filterOnCall,
      onPrequalification: this.filterOnPrequalification,
      hasReminder: this.filterReminders,
      hasVisit: this.filterVisits,
      transferred: this.filterTransfereds ? 1 : 0,
      contacteds: this.filterContacteds,
      nonContacteds: this.filterNotContacteds,
      filterNewLead: this.filterNewLead,
      filterOnTrackCold: this.filterOnTrackCold,
      filterOnTrackHot: this.filterOnTrackHot,
      filterOnTrackWarm: this.filterOnTrackWarm,
      filterArchived: this.filterArchived,
      archivedDateRange: this.archivedDateRange,
      archivedNotContacted: this.archivedNotContacted,
      archivedNotInterested: this.archivedNotInterested,
      archivedOther: this.archivedOther,
      archivedComment: this.filter.archivedComment,
      filterClosed: this.filterClosed,
      closeDateRange: this.closeDateRange,
      closedComment: this.filter.closedComment,
    };

    this.filter.onCall = this.filterOnCall;
    this.filter.onPrequalification = this.filterOnPrequalification;
    this.filter.hasReminder = this.filterReminders;
    this.filter.hasVisit = this.filterVisits;
    this.filter.transferred = this.filterTransfereds ? 1 : 0;

    if (this.filterOnTrackCold) {
      this.filter.status.push('on_track');
      this.filter.onTrack.push('cold');
    }

    if (this.filterOnTrackWarm) {
      this.filter.status.push('on_track');
      this.filter.onTrack.push('warm');
    }

    if (this.filterOnTrackHot) {
      this.filter.status.push('on_track');
      this.filter.onTrack.push('hot');
    }

    if (this.filterNewLead) {
      this.filter.status.push('new');
    }

    if (this.filterClosed) {
      this.filter.status.push('closed');
    }

    this.filter.hasContacted = this.filterContacteds;
    this.filter.notContacted = this.filterNotContacteds;

    this.dashboardComuService.applyFilter(this.filter, filterForView);
    this.saveFilter();
    this.sending = false;

  }
  saveFilter(): void {
    const filterSave = {
      status: this.filter.status,
      closedAtFrom: this.filter.closedAtFrom,
      closedAtTo: this.filter.closedAtTo,
      closedComment: this.filter.closedComment,
      filterClosed: this.filterClosed,
      visitDateFrom: this.filter.visitDateFrom,
      visitDateTo: this.filter.visitDateTo,
      reminderDateFrom: this.filter.reminderDateFrom,
      reminderDateTo: this.filter.reminderDateTo,
      createdAtFrom: this.filter.createdAtFrom,
      createdAtTo: this.filter.createdAtTo,
      updatedAtFrom: this.filter.updatedAtFrom,
      updatedAtTo: this.filter.updatedAtTo,
      filterArchived: this.filterArchived,
      archivedAtFrom: this.filter.archivedAtFrom,
      archivedAtTo: this.filter.archivedAtTo,
      archivedComment: this.filter.archivedComment,
      archivedNotContacted: this.archivedNotContacted,
      archivedNotInterested: this.archivedNotInterested,
      archivedOther: this.archivedOther,
      dateUpdateModel: this.dateUpdateModel,
      dateModel: this.dateModel,
      filterNewLead: this.filterNewLead,
      filterOnTrackHot: this.filterOnTrackHot,
      filterOnTrackWarm: this.filterOnTrackWarm,
      filterOnTrackCold: this.filterOnTrackCold,
      filterContacteds: this.filterContacteds,
      notContacted: this.filterNotContacteds,
      filterOnCall: this.filterOnCall,
      filterOnPrequalification: this.filterOnPrequalification,
      filterTransfered: this.filterTransfereds,
      onTrackModal: this.onTrackModal,
      filterTransfereds: this.filterTransfereds,
      companiesSelectionComponentSelectedItems: this.companiesSelectionComponent.selectedItems,
      brandSelectionComponentSelectedItems: this.brandSelectionComponent.selectedItems,
      channelSelectionComponentSelectedItems: this.channelSelectionComponent.selectedItems,
      typesSelectionComponentSelectedItems: this.typesSelectionComponent.selectedItems,
    };
    localStorage.setItem(Filter.NEW_DASHBOARD, JSON.stringify(filterSave));
  }

  generateFilterFromLocalStorage(): void {
    const filterLocalStorage = JSON.parse(localStorage.getItem(Filter.NEW_DASHBOARD));
    if (!filterLocalStorage) {
      return;
    }
    this.filter.status = filterLocalStorage.status;
    this.filterArchived = filterLocalStorage.filterArchived;
    this.filter.archivedComment = filterLocalStorage.archivedComment;
    this.archivedNotContacted = filterLocalStorage.archivedNotContacted;
    this.archivedNotInterested = filterLocalStorage.archivedNotInterested;
    this.archivedOther = filterLocalStorage.archivedOther;
    this.archivedDateRange = {
      start: filterLocalStorage.archivedAtFrom
        ? new Date(filterLocalStorage.archivedAtFrom)
        : null,
      end: filterLocalStorage.archivedAtTo
        ? new Date(filterLocalStorage.archivedAtTo)
        : null,
    };

    this.filter.closedComment = filterLocalStorage.closedComment;
    this.filterClosed = filterLocalStorage.filterClosed;
    this.closeDateRange = {
      start: filterLocalStorage.closedAtFrom
        ? new Date(filterLocalStorage.closedAtFrom)
        : null,
      end: filterLocalStorage.closedAtTo
        ? new Date(filterLocalStorage.closedAtTo)
        : null,
    };

    this.rangeUpdate = {
      start: filterLocalStorage.updatedAtFrom
        ? new Date(filterLocalStorage.updatedAtFrom)
        : null,
      end: filterLocalStorage.updatedAtTo
        ? new Date(filterLocalStorage.updatedAtTo)
        : null,
    };
    this.rangeCreate = {
      start: filterLocalStorage.createdAtFrom
        ? new Date(filterLocalStorage.createdAtFrom)
        : null,
      end: filterLocalStorage.createdAtTo
        ? new Date(filterLocalStorage.createdAtTo)
        : null,
    };

    this.rangeVisit = {
      start: filterLocalStorage.visitDateFrom
        ? new Date(filterLocalStorage.visitDateFrom)
        : null,
      end: filterLocalStorage.visitDateTo
        ? new Date(filterLocalStorage.visitDateTo)
        : null,
    };
    this.rangeReminder = {
      start: filterLocalStorage.reminderDateFrom
        ? new Date(filterLocalStorage.reminderDateFrom)
        : null,
      end: filterLocalStorage.reminderDateTo
        ? new Date(filterLocalStorage.reminderDateTo)
        : null,
    };
    this.filterNewLead = filterLocalStorage.filterNewLead;
    this.filterOnTrackHot = filterLocalStorage.filterOnTrackHot;
    this.filterOnTrackWarm = filterLocalStorage.filterOnTrackWarm;
    this.filterOnTrackCold = filterLocalStorage.filterOnTrackCold;
    this.filterOnCall = filterLocalStorage.filterOnCall;
    this.filterOnPrequalification = filterLocalStorage.filterOnPrequalification;
    this.filterTransfereds = filterLocalStorage.filterTransfereds;
    this.filterContacteds = filterLocalStorage.filterContacteds;
    this.filterNotContacteds = filterLocalStorage.notContacted;
    this.rangeSelected = filterLocalStorage.rangeSelected;
    this.dateUpdateModel = filterLocalStorage.dateUpdateModel;
    this.dateModel = filterLocalStorage.dateModel;
    this.onTrackModal = filterLocalStorage.onTrackModal;
    this.companiesSelectionComponent.selectedItems = filterLocalStorage.companiesSelectionComponentSelectedItems || [];
    this.companySelected = filterLocalStorage.companiesSelectionComponentSelectedItems || [];
    this.brandSelectionComponent.selectedItems = filterLocalStorage.brandSelectionComponentSelectedItems || [];
    this.brandsSelected = filterLocalStorage.brandSelectionComponentSelectedItems || [];
    this.channelSelectionComponent.selectedItems = filterLocalStorage.channelSelectionComponentSelectedItems || [];
    this.channelSelected = filterLocalStorage.channelSelectionComponentSelectedItems || [];
    this.typesSelectionComponent.selectedItems = filterLocalStorage.typesSelectionComponentSelectedItems || [];
    this.typesSelected = filterLocalStorage.typesSelectionComponentSelectedItems || [];
  }

  clearDateClosed(): void {
    this.filter.closedAtFrom = null;
    this.filter.closedAtTo = null;
    this.closeDateRange = { start: null, end: null };
  }

  haveFiltersApplied(): boolean {
    if (!this.isPageLoaded) {
      return false;
    }

    return Boolean(
      this.filterClosed
      || this.isDateClosedFilterSelected()
      || this.filterArchived
      || this.filterVisits
      || this.filterReminders
      || this.filterNewLead
      || this.onTrackModal
      || this.filterOnCall
      || this.filterOnPrequalification
      || this.filterTransfereds
      || this.filterOnTrackHot
      || this.filterOnTrackWarm
      || this.filterOnTrackCold
      || this.isLeadInformationSelected()
      || this.isDateVisitFilterSelected()
      || this.isDateReminderFilterSelected()
      || this.isDateFilterSelected()
      || this.isDateUpdateFilterSelected()
      || this.isDateArchivedFilterSelected())
      ;
  }

  clearFilter(): void {
    this.filter = new DashboardFilter();
    this.filterClosed = false;
    this.filterArchived = false;
    this.archivedNotContacted = false;
    this.archivedNotInterested = false;
    this.archivedOther = false;
    this.filterOnTrackCold = false;
    this.filterOnTrackHot = false;
    this.filterOnTrackWarm = false;
    this.filterNewLead = false;
    this.filterContacteds = false;
    this.filterNotContacteds = false;
    this.filterOnCall = false;
    this.filterOnPrequalification = false;
    this.filterTransfereds = false;
    this.clearDateReminder();
    this.clearDateVisit();
    this.onTrackModal = '';

    this.clearDateFilter();
    this.clearDateUpdateFilter();

    this.clearDateArchived();

    localStorage.removeItem(Filter.NEW_DASHBOARD);
    this.clearDateClosed();

    this.brandSelectionComponent.selectedItems = [];
    this.channelSelectionComponent.selectedItems = [];
    this.typesSelectionComponent.selectedItems = [];
    this.companiesSelectionComponent.selectedItems = [];
  }

  resetFilter(): void {
    this.clearFilter();
    this.applyFilter();
  }

  closedDateRangeForFilter(): void {
    if (this.closeDateRange.start) {
      this.filter.closedAtFrom = this.closeDateRange.start;
      if (!this.closeDateRange.end) {
        this.closeDateRange.end = new Date(this.closeDateRange.start);
      }
      this.closeDateRange.end.setHours(23, 59, 59);
      this.filter.closedAtTo = this.closeDateRange.end;
    }
  }

  clearDateVisit(): void {
    this.filterVisits = false;
    this.filter.hasVisit = false;
    this.filter.visitDateFrom = null;
    this.filter.visitDateTo = null;
    this.rangeVisit = { start: null, end: null };
    this.filterVisits = false;
  }
  clearDateReminder(): void {
    this.filter.reminderDateFrom = null;
    this.filter.reminderDateTo = null;
    this.rangeReminder = { start: null, end: null };
    this.filterReminders = false;
  }

  visitDateRangeForFilter(): void {
    if (this.rangeVisit.start) {
      this.filter.visitDateFrom = this.rangeVisit.start;
      if (!this.rangeVisit.end) {
        this.rangeVisit.end = new Date(this.rangeVisit.start);
      }
      this.rangeVisit.end.setHours(23, 59, 59);
      this.filter.visitDateTo = this.rangeVisit.end;
      this.filterVisits = true;
    }
  }
  reminderDateRangeForFilter(): void {
    if (this.rangeReminder.start) {
      this.filter.reminderDateFrom = this.rangeReminder.start;
      if (!this.rangeReminder.end) {
        this.rangeReminder.end = new Date(this.rangeReminder.start);
      }
      this.rangeReminder.end.setHours(23, 59, 59);
      this.filter.reminderDateTo = this.rangeReminder.end;
      this.filterReminders = true;
    }
  }

  selectDateFilter(amount: number, filter?: any): void {
    this.rangeSelected = '';
    this.filterDate = filter;
    this.today = moment();
    const newdate = moment().subtract(amount, 'days');

    this.rangeCreate.end =
      filter === 'yesterday' ? newdate.toDate() : this.today.toDate();

    this.rangeCreate.start = newdate.toDate();
    this.rangeCreate.start.setHours(0, 0, 0);
  }

  toggleContact(option: string) {

    if (this.onTrackModal === option) {
      this.onTrackModal = '';
    } else {
      this.onTrackModal = option;
    }

    if (this.onTrackModal === 'contacteds') {
      this.filterContacteds = true;
      this.filterNotContacteds = false;
      return;
    }
    if (this.onTrackModal === 'not_contacteds') {
      this.filterContacteds = false;
      this.filterNotContacteds = true;
      return;
    }
    this.filterContacteds = false;
    this.filterNotContacteds = false;
  }

  createdDateRangeChange(range): void {
    let endDate = '?';
    if (range.end) {
      endDate = moment(range.end).format('D/M/YYYY');
    }
    this.rangeSelected = `${moment(range.start).format(
      'D/M/YYYY'
    )} - ${endDate}`;
  }
  clearDateFilter(): void {
    this.filterDate = '';
    this.rangeSelected = '';
    this.filter.createdAtFrom = null;
    this.filter.createdAtTo = null;
    this.dateModel = '';
    this.rangeCreate = { start: null, end: null };
  }

  selectDateUpdateFilter(amount: number, filter?: any): void {
    this.rangeUpdatedSelected = '';
    this.filterDateUpdate = filter;
    this.today = moment();
    const newdate = moment().subtract(amount, 'days');

    this.rangeUpdate.end =
      filter === 'yesterday' ? newdate.toDate() : this.today.toDate();

    this.rangeUpdate.start = newdate.toDate();
    this.rangeUpdate.start.setHours(0, 0, 0);
  }

  updatedDateRangeChange(range): void {
    let endDate = '?';
    if (range.end) {
      endDate = moment(range.end).format('D/M/YYYY');
    }
    this.rangeUpdatedSelected = `${moment(range.start).format(
      'D/M/YYYY'
    )} - ${endDate}`;
  }

  clearDateUpdateFilter(): void {
    this.filterDateUpdate = '';
    this.rangeUpdatedSelected = '';
    this.filter.updatedAtFrom = null;
    this.filter.updatedAtFrom = null;
    this.dateUpdateModel = '';
    this.rangeUpdate = { start: null, end: null };
  }

  createDateRangeForFilter(): void {
    if (this.rangeCreate.start) {
      this.filter.createdAtFrom = this.rangeCreate.start;
      if (!this.rangeCreate.end) {
        this.rangeCreate.end = new Date(this.rangeCreate.start);
        this.rangeSelected = `${moment(this.rangeCreate.start).format(
          'D/M/YYYY'
        )} - ${moment(this.rangeCreate.end).format('D/M/YYYY')}`;
      }
      this.rangeCreate.end.setHours(23, 59, 59);
      this.filter.createdAtTo = this.rangeCreate.end;
    }
  }

  createDateUpdateRangeForFilter(): void {
    if (this.rangeUpdate.start) {
      this.filter.updatedAtFrom = this.rangeUpdate.start;
      if (!this.rangeUpdate.end) {
        this.rangeUpdate.end = new Date(this.rangeUpdate.start);
        this.rangeSelected = `${moment(this.rangeUpdate.start).format(
          'D/M/YYYY'
        )} - ${moment(this.rangeUpdate.end).format('D/M/YYYY')}`;
      }
      this.rangeUpdate.end.setHours(23, 59, 59);
      this.filter.updatedAtTo = this.rangeUpdate.end;
    }
  }

  clearDateArchived(): void {
    this.filter.archivedAtFrom = null;
    this.filter.archivedAtTo = null;
    this.archivedDateRange = { start: null, end: null };
  }

  archivedDateRangeForFilter(): void {
    if (this.archivedDateRange.start) {
      this.filter.archivedAtFrom = this.archivedDateRange.start;
      if (!this.archivedDateRange.end) {
        this.archivedDateRange.end = new Date(this.archivedDateRange.start);
      }
      this.archivedDateRange.end.setHours(23, 59, 59);
      this.filter.archivedAtTo = this.archivedDateRange.end;
      this.filter.archivedAtTo = this.archivedDateRange.end;
    }
  }

  private isDateArchivedFilterSelected(): boolean {
    return Boolean(
      this.filter.archivedAtFrom ||
      this.filter.archivedAtTo ||
      (this.archivedDateRange &&
        (this.archivedDateRange.start || this.archivedDateRange.end))
    );
  }

  filterByOptionArchived(option: string): void {
    switch (option) {
      case 'not_contacted':
        this.archivedNotContacted = !this.archivedNotContacted;
        break;
      case 'not_interested':
        this.archivedNotInterested = !this.archivedNotInterested;
        break;
      case 'other':
        this.archivedOther = !this.archivedOther;
        break;
      default:
        break;
    }

    if (this.archivedOther || this.archivedNotInterested || this.archivedNotContacted) {
      this.filterArchived = true;
    } else {
      this.filterArchived = false;
      this.filter.archivedComment = '';
      this.archivedDateRange = { start: null, end: null };
    }
  }

  addFilterArchived(): void {
    this.filterArchived = !this.filterArchived;
    if (this.filterArchived) {
      this.filter.status.push('archived');
    } else {
      this.removeElement('archived', this.filter.status);
      this.filter.archivedComment = '';
      this.archivedDateRange = { start: null, end: null };
    }
    if (
      this.filterArchived &&
      !this.archivedNotContacted &&
      !this.archivedNotInterested &&
      !this.archivedOther
    ) {
      this.archivedNotContacted = true;
      this.archivedNotInterested = true;
      this.archivedOther = true;
    }

    if (!this.filterArchived) {
      this.archivedNotContacted = false;
      this.archivedNotInterested = false;
      this.archivedOther = false;
    }
  }

  private isDateClosedFilterSelected(): boolean {
    return Boolean(
      this.filter.closedAtFrom ||
      this.filter.closedAtTo ||
      (this.closeDateRange &&
        (this.closeDateRange.start || this.closeDateRange.end))
    );
  }

  private isDateReminderFilterSelected(): boolean {
    return Boolean(
      this.filter.reminderDateFrom ||
      this.filter.reminderDateTo ||
      (this.rangeReminder &&
        (this.rangeReminder.start || this.rangeReminder.end))
    );
  }

  private isDateVisitFilterSelected(): boolean {
    return Boolean(
      this.filter.visitDateFrom ||
      this.filter.visitDateTo ||
      (this.rangeVisit && (this.rangeVisit.start || this.rangeVisit.end))
    );
  }

  private isLeadInformationSelected() {
    return (this.companiesSelectionComponent && this.companiesSelectionComponent.selectedItems.length > 0)
      || (this.brandSelectionComponent && this.brandSelectionComponent.selectedItems.length > 0)
      || (this.channelSelectionComponent && this.channelSelectionComponent.selectedItems.length > 0)
      || (this.typesSelectionComponent && this.typesSelectionComponent.selectedItems.length > 0);
  }

  private isDateFilterSelected(): boolean {
    return Boolean(this.rangeCreate.end || this.rangeCreate.start);
  }
  private isDateUpdateFilterSelected(): boolean {
    return Boolean(this.rangeUpdate.end || this.rangeUpdate.start);
  }

  toggleFilterClosed() {

    this.filterClosed = !this.filterClosed;
    if (this.filterClosed) {
      this.filter.status.push('closed');
    } else {
      this.removeElement('closed', this.filter.status);
      this.filter.closedComment = '';
      this.closeDateRange = { start: null, end: null };
    }
  }

  private removeElement(element: any, array: any[]) {
    const index = array.indexOf(element);
    if (index !== -1) {
      array.splice(index, 1);
    }

  }

  filterByOnTrack(option: string) {

    switch (option) {
      case 'hot':
        this.filterOnTrackHot = !this.filterOnTrackHot;
        break;
      case 'cold':
        this.filterOnTrackCold = !this.filterOnTrackCold;
        break;
      case 'warm':
        this.filterOnTrackWarm = !this.filterOnTrackWarm;
        break;
      default:
        break;
    }
    if (this.checkStateDeselected()) {
      this.removeOnTrack(this.filter.status);
    }
    if (this.checkFirstStateOnTrack()) {
      this.addFirstStateOnTrack(option);
    } else {
      this.addStateOnTrack(option);
    }
  }

  private removeOnTrack(arreglo: any[]) {
    const index = arreglo.indexOf('on_track');
    if (index !== -1) {
      arreglo.splice(index, 1);
    }
  }
  checkStateDeselected() {
    return !this.filterOnTrackHot && !this.filterOnTrackWarm && !this.filterOnTrackCold &&
      this.filter.status.includes('on_track');
  }
  checkFirstStateOnTrack() {
    return (this.filterOnTrackHot || this.filterOnTrackCold || this.filterOnTrackWarm) &&
      !this.filter.status.includes('on_track');
  }

  addStateOnTrack(state) {
    this.addOrRemoveStateOnTrack(state);
  }

  addFirstStateOnTrack(state: string) {
    this.filter.status.push('on_track');
    this.addOrRemoveStateOnTrack(state);
  }

  addOrRemoveStateOnTrack(state: string) {
    const existState = this.filter.onTrack.includes(state);
    if (!existState) {
      this.filter.onTrack.push(state);
    } else {
      this.removeElement(state, this.filter.onTrack);
    }
  }

  checkOnTrackApplied(firstOnTrack: boolean, filterOption: any, state: string) {
    if (firstOnTrack) {
      if (filterOption) {
        this.filter.onTrack.push(state);
      } else {
        this.removeElement(state, this.filter.onTrack);
      }
    } else {
      if (!filterOption) {
        this.removeElement(state, this.filter.onTrack);
      } else if (!this.filter.onTrack.includes(state)) {
        this.filter.onTrack.push(state);
      }
    }
  }

  filterByNew() {
    this.filterNewLead = !this.filterNewLead;
    if (this.filterNewLead) {
      this.filter.status.push('new');
    } else {
      this.removeElement('new', this.filter.status);
    }
  }
}
